'use strict';

$(function () {
    $('.criteo-async-ad').asyncLoad(function () {
        const $criteoBannerLink = $('#criteo-banner-link');
        $criteoBannerLink.on('click', function () {
            CriteoBannerTracker.sendOnClickEvent($criteoBannerLink.data('on-click-beacon'));
        });

        const onLoadBeacon = $criteoBannerLink.data('on-load-beacon');
        if (onLoadBeacon) {
            CriteoBannerTracker.sendOnLoadEvent(onLoadBeacon);
        }
        const onViewBeacon = $criteoBannerLink.data('on-view-beacon');
        if (onViewBeacon) {
            CriteoBannerTracker.registerOnViewEvent($criteoBannerLink, onViewBeacon);
        }
    });
});